import request from '@/base/service'
const baseURL = process.env.VUE_APP_HELP_DOC
const requestB = (data) => {
  return request({ ...data, ...{ baseURL } })
}

// 用户激活码激活
export function helpDocUrl(data) {
  return requestB({
    url: 'aggregateservice-web/api/Home/Help',
    method: 'post',
    data
  })
}

//  涉及到的下拉选项
export function listDictionaryOption(data) {
  return request({
    url: '/tcloud-component/dictionary/listDictionaryOption',
    method: 'get',
    params: data
  })
}
//  省市区
export function listGeologyTree() {
  return request({
    url: '/tcloud-component/geology/listGeologyTree',
    method: 'get'
  })
}

// 角色展示
export function listRoleName() {
  return request({
    url: '/tcloud-account/employeeRole/listRoleName',
    method: 'post'
  })
}

// 账户余额
export function accountBalance() {
  return request({
    url: '/tcloud-account/payTrade/accountBalance',
    method: 'get'
  })
}

// 查看个人积分总值
export function selectMyCredit() {
  return request({
    url: '/tcloud-account/credit/selectMyCredit',
    method: 'get'
  })
}

// 查看营业执照过期
export function checkAuthenticationValidate() {
  return request({
    url: '/tcloud-account/authentication/checkAuthenticationValidate',
    method: 'get'
  })
}

// 查看营业执照,实名认证,购买产品等是否过期
export function getAuthenticationStatus() {
  return request({
    url: '/tcloud-account/authentication/getAuthenticationStatus',
    method: 'get'
  })
}

//  查看用户基本信息
export function getAccountInfo() {
  return request({
    url: '/tcloud-account/account/getAccountInfo',
    method: 'get'
  })
}

//  获取用户是否有未激活的订单
export function GetUserHasNeverActivateOrder(data) {
  return request({
    url: '/aggregateservice-web/api/User_Product/GetUserHasNeverActivateOrder',
    method: 'post',
    data
  })
}

//  获取产品分类
export function AllCategory() {
  return request({
    url: '/aggregateservice-web/api/Category/AllCategory',
    method: 'get'
  })
}

//  激活订单
export function ActivateUserOrder(data) {
  return request({
    url: '/aggregateservice-web/api/User_Product/ActivateUserOrder',
    method: 'post',
    data
  })
}

//  激活订单发送验证码
export function SendMobileCode(data) {
  return request({
    url: '/aggregateservice-web/api/User_Product/SendMobileCode',
    method: 'post',
    data
  })
}

//  获取产品与服务
export function getProductUrl() {
  return request({
    url: '/aggregateservice-web/api/Home/GetProductUrl',
    method: 'post',
    data: {}
  })
}
//  获取最近访问
export function getListOperations() {
  return request({
    url: '/menu/listOperations',
    method: 'get'
  })
}
//  设置最近访问
export function setListOperations(data) {
  return request({
    url: '/menu/logOperations',
    method: 'post',
    data
  })
}
// 产品与服务列表
export function getAllMenu() {
  return request({
    url: '/aggregateservice-web/api/Home/GetAllMenu',
    method: 'post',
    data: {}
  })
}
// 获取快捷菜单
export function getShortcutMenu() {
  return request({
    url: '/aggregateservice-web/api/Home/GetShortcutMenu',
    method: 'post',
    data: {}
  })
}

// 设置快捷菜单
export function setShortcutMenu(data) {
  return request({
    url: '/aggregateservice-web/api/Home/SetShortcutMenu',
    method: 'post',
    data
  })
}

export function GetInformatizationUrl(postData) {
  return request({
    url: '/aggregateservice-web/api/Home/GetInformatizationUrl',
    method: 'post',
    data: postData
  })
}
export function OpenInformatization(postData) {
  return request({
    url: '/aggregateservice-web/api/Home/OpenInformatization',
    method: 'post',
    data: postData
  })
}
